import { useEffect, useState } from "react";

import { useFlocknoteAppState } from "Flocknote/state";

import Portal from "Utilities/PortalMaker";
import { useDashboardPortalElement } from "Utilities/PortalMaker/useDashboardPortalElement";

import DashboardCards from "./DashboardCards";
import AnimateEntrance from "./DashboardRightSections/AnimateEntrance";

export default function FullWidthDashboardPortal() {
  const [state] = useFlocknoteAppState();
  const [childCount, setChildCount] = useState(0);
  const portalToElement = useDashboardPortalElement({
    selector: "#full_width_dashboard_portal_anchor",
    childCount,
    setChildCount,
    dashboardTick: state.dashboardTick,
  });

  useEffect(() => {
    if (portalToElement?.childElementCount) {
      setChildCount(portalToElement.childElementCount);
    }
  }, [portalToElement]);

  if (!portalToElement) return null;

  return (
    <Portal to={portalToElement}>
      <AnimateEntrance delay={0} data-cy="FullWidthDashboard_Container">
        <DashboardCards />
      </AnimateEntrance>
    </Portal>
  );
}
